import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function initializeCustomAction(): InfoBarCustomAction {
    return {
        text: null,
        action: null,
    };
}
